import * as yup from "yup"

export const profilValidation = yup.object().shape({
    divisi_id : yup.string().label("Division Name").required(),
    department_id: yup.string().label("Departement").required(),
    employee_id : yup.string().label("Employee").required(),
    warranty_period: yup.string().label("Warranty Periode").required(),
    warranty_expired: yup.string().label("Warranty Expired").nullable(),
    insured : yup.string().label("Insured").required(),
    insurance_policy: yup.string().label("Insurance Policy Number").optional(),
    insurance_expired: yup.string().label("Insurance Expire Date").nullable(),
    coa_asset_id: yup.string().label("Account Asset").required(),
    coa_depreciation_id: yup.string().label("Account Depreciation").required(),
    coa_disposal_id: yup.string().label("Account Disposal").required(),
    asset_profile_id: yup.string().label("Asset Profile").optional(),
})

export type ProfilAssetType = yup.InferType<typeof profilValidation>